module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_0.9d4fb21e.png";